import {
	FETCH_STATES, FETCH_STATES_SUCCESS, FETCH_STATES_FAILURE, RESET_STATES
} from '../actions/states';

const INITIAL_STATE = {
    statesList: {states: [], error:null, loading: false}
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {
        case FETCH_STATES:// start fetching states and set loading = true
            return { ...state, statesList: {states:[], error: null, loading: true} };
        case FETCH_STATES_SUCCESS:// return list of states and make loading = false
            return { ...state, statesList: {states: action.payload, error:null, loading: false} };
        case FETCH_STATES_FAILURE:// return error and make loading = false
            error = action.payload || {message: action.payload.message};//2nd one is network or server down errors
            return { ...state, statesList: {states: [], error: error, loading: false} };
        case RESET_STATES:// reset statesList to initial state
            return { ...state, statesList: {states: [], error:null, loading: false} };
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/reducer_states.js
 **/